import { useEffect } from 'react';

export function getFocusable(root) {
  if (!root) {
    return [];
  }
  return Array.from(root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
    .filter((node) => !node.hasAttribute('disabled') && node.getAttribute('aria-hidden') !== 'true');
}

export function useFocusTrap(active, containerRef, onEscape) {
  useEffect(() => {
    if (!active) {
      return undefined;
    }
    const node = containerRef.current;
    const previous = document.activeElement;
    const focusFirst = () => {
      const focusable = getFocusable(node);
      (focusable[0] || node)?.focus?.();
    };
    focusFirst();

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onEscape?.();
        return;
      }
      if (event.key !== 'Tab') {
        return;
      }
      const focusable = getFocusable(node);
      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      if (previous && typeof previous.focus === 'function' && document.contains(previous)) {
        previous.focus();
      }
    };
  }, [active, containerRef, onEscape]);
}
